<div class="container">
    @for (location of locations; track $index) {
    <div>
        <div class="content">
            <div class="location-icon">
                @if (redesign) {
                <svg-icon class="icon" src="/assets/icons/location-pin.svg" [svgClass]="'location-pin'"></svg-icon>
                } @else {
                <svg-icon class="icon" [class]="location.isWithInCompleteLocation ? 'location-incompleted':'location-completed'" [src]="location.isWithInCompleteLocation ? '/assets/icons/location-hidden.svg' : '/assets/icons/location.svg'"></svg-icon>
                }
            </div>

            <div class="location-items">
                @for (item of location.announcementExtendedLocationParts; track $index; let last = $last) {
                <span class="locaion-item">{{item.name}}{{last ? '' : ', '}} </span>
                }
            </div>
        </div>
    </div>
    }
</div>
